import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import { database } from '@/plugins/firebase';
import { callFn } from '@/utils/functionsClient';
import Snackbar from '@/components/Snackbar.vue';
import { EET_STATUSES, EET_STATUS_COLORS, EET_STATUS_TITLES, paymentMethodTitle, } from '@/constants/PaymentMethods';
const UNCONFIRMED_STATUSES = ['pending', 'failed'];
const STALE_HOURS = 24;
let Receipts = class Receipts extends Vue {
    eetFilter = '';
    retryingId = '';
    unsubscribe = null;
    unsubscribeRequests = null;
    unfinishedPayments = [];
    finishingId = '';
    /** The PDF link waits on a signed storage URL. */
    pdfId = '';
    headers = [
        { text: 'Číslo', value: 'data.number' },
        { text: 'Vystaveno', value: 'data.issuedAt' },
        { text: 'Předmět', value: 'data.subject.label' },
        { text: 'Částka', value: 'data.amount' },
        { text: 'Platba', value: 'data.method' },
        { text: 'Přijal', value: 'data.acceptedBy.name' },
        { text: 'EET', value: 'eet', sortable: false },
        { text: '', value: 'actions', sortable: false },
    ];
    eetStatusOptions = [
        { text: 'Vše', value: '' },
        ...EET_STATUSES.map(status => ({ text: status.title, value: status.id })),
    ];
    async mounted() {
        this.unsubscribe = await this.$store.dispatch('receipt/listen');
        this.watchUnfinishedPayments();
    }
    beforeDestroy() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
        if (this.unsubscribeRequests) {
            this.unsubscribeRequests();
        }
    }
    /** A terminal charge whose receipt was never written has money with no record behind it. */
    watchUnfinishedPayments() {
        this.unsubscribeRequests = database.collection('paymentRequests')
            .where('kind', '==', 'card_payment')
            .where('status', '==', 'done')
            .onSnapshot(snapshot => {
            this.unfinishedPayments = snapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(request => !request.receiptId)
                .sort((a, b) => b.createdAt.toMillis() - a.createdAt.toMillis());
        }, error => console.error(error));
    }
    instructorName(uid) {
        const instructors = this.$store.getters['instructor/fullNames'];
        return instructors.find(x => x.id === uid)?.fullName ?? '';
    }
    formatTimestamp(createdAt) {
        return moment(createdAt.toDate()).format('D. M. YYYY HH:mm');
    }
    async finishPayment(request) {
        if (this.finishingId)
            return;
        this.finishingId = request.id;
        try {
            const result = await callFn('finalizeCardPayment', {
                requestId: request.id,
            });
            Snackbar.success(`Doklad ${result.number} vystaven.`);
            if (result.warning) {
                Snackbar.info(result.warning);
            }
        }
        catch (e) {
            console.error(e);
            Snackbar.error(e instanceof Error ? e.message : 'Platbu se nepodařilo dokončit');
        }
        finally {
            this.finishingId = '';
        }
    }
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    get receipts() {
        return this.$store.getters['receipt/active'];
    }
    get filteredReceipts() {
        if (!this.eetFilter) {
            return this.receipts;
        }
        return this.receipts.filter(receipt => this.eetStatus(receipt) === this.eetFilter);
    }
    /** Takings waiting for an EET confirmation for more than a day need a human. */
    get staleReceipts() {
        return this.receipts.filter(receipt => UNCONFIRMED_STATUSES.includes(this.eetStatus(receipt))
            && moment(receipt.data.issuedAt).isBefore(moment().subtract(STALE_HOURS, 'hours')));
    }
    eetStatus(receipt) {
        return receipt.data.eet?.status ?? 'skipped';
    }
    eetTitle(receipt) {
        const status = this.eetStatus(receipt);
        return EET_STATUS_TITLES[status] ?? status;
    }
    eetColor(receipt) {
        return EET_STATUS_COLORS[this.eetStatus(receipt)] ?? 'grey';
    }
    methodTitle(method) {
        return paymentMethodTitle(method);
    }
    formatDateTime(issuedAt) {
        return moment(issuedAt).format('D. M. YYYY HH:mm');
    }
    canRetry(receipt) {
        return UNCONFIRMED_STATUSES.includes(this.eetStatus(receipt));
    }
    async retryEet(receipt) {
        if (this.retryingId)
            return;
        this.retryingId = receipt.id;
        try {
            const result = await this.$store.dispatch('receipt/retryEet', receipt);
            Snackbar.success(result.pok
                ? `Doklad potvrzen, FIK ${result.pok}.`
                : 'Doklad byl znovu odeslán do EET.');
        }
        catch (e) {
            console.error(e);
            Snackbar.error(e instanceof Error ? e.message : 'Doklad se nepodařilo odeslat');
        }
        finally {
            this.retryingId = '';
        }
    }
    async openPdf(receipt) {
        this.pdfId = receipt.id;
        try {
            window.open(await this.$store.dispatch('receipt/pdfUrl', receipt), '_blank');
        }
        catch (e) {
            console.error(e);
            Snackbar.error('PDF se nepodařilo otevřít');
        }
        finally {
            this.pdfId = '';
        }
    }
};
Receipts = __decorate([
    Component
], Receipts);
export default Receipts;
